import { OsType } from '../types'

export const isMobileOs = (osType: OsType) =>
  ['android', 'ios'].includes(osType)

export const isDesktopOs = (osType: OsType) =>
  ['windows', 'macos'].includes(osType)
